import { render, staticRenderFns } from "./cq.vue?vue&type=template&id=130fde19&scoped=true&"
var script = {}
import style0 from "./cq.vue?vue&type=style&index=0&id=130fde19&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130fde19",
  null
  
)

export default component.exports